export type HealthReference = {
  label: string;
  url: string;
  description: string;
};

export const HEALTH_DISCLAIMER_TITLE = "Tracks user-entered observations only";

export const HEALTH_DISCLAIMER_BODY =
  "NFP Tracker records the observations you enter and shows educational summaries based on your selected method and logged data. It is not intended to diagnose, treat, or prevent pregnancy or any medical condition.";

export const HEALTH_DISCLAIMER_FOOTER =
  "For interpretation, family planning decisions, symptoms, or medical concerns, consult a licensed clinician or certified instructor.";

export const HEALTH_REFERENCES: HealthReference[] = [
  {
    label: "ACOG: Fertility Awareness-Based Methods of Family Planning",
    url: "https://www.acog.org/womens-health/faqs/fertility-awareness-based-methods-of-family-planning",
    description: "General background on fertility-awareness methods and their limits.",
  },
  {
    label: "Office on Women's Health: Menstrual cycle basics",
    url: "https://www.womenshealth.gov/menstrual-cycle/your-menstrual-cycle",
    description: "General educational information about the menstrual cycle.",
  },
  {
    label: "Marquette Method",
    url: "https://www.marquettemethod.com/",
    description: "Official Marquette Method resources and instructor-led guidance.",
  },
  {
    label: "Creighton Model FertilityCare System",
    url: "https://creightonmodel.com/",
    description: "Official Creighton Model resources and practitioner directory.",
  },
  {
    label: "Couple to Couple League",
    url: "https://ccli.org/",
    description: "Sympto-thermal method education and instructor resources.",
  },
  {
    label: "Billings Ovulation Method",
    url: "https://billings.life/en/",
    description: "Official Billings method resources and teacher support.",
  },
];
